import { Block } from '../';
import { Text, InnerBlocks } from '../components';

export default class Hero extends Block {
  static attributes() {
    return {
      header: Text,
    };
  }

  render() {
    return (
      <div>
        <Text attr="header" tagName="h1" context={this.state} />
        <InnerBlocks context={this.state} />
      </div>
    );
  }
}
